import { Button } from "@/components/ui/button";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import { useInitialChainSelector } from "@/providers/initialChainContext";
import { COTI_TESTNET_HEX } from "@/components/NetworkSelector";

const DEFAULT_CONNECT_CHAIN =
  import.meta.env.VITE_DEFAULT_NETWORK_ID || COTI_TESTNET_HEX;

interface NavbarConnectButtonProps {
  label?: string;
}

const NavbarConnectButton = ({ label = "COTI Wallet" }: NavbarConnectButtonProps) => {
  const { openConnectModal } = useConnectModal();
  const { setInitialChainId } = useInitialChainSelector();

  const handleConnect = () => {
    setInitialChainId(parseInt(DEFAULT_CONNECT_CHAIN, 16));
    openConnectModal?.();
  };

  return (
    <Button
      onClick={handleConnect}
      className="transition-all duration-300 rounded-full font-display font-medium text-sm px-6 h-10"
    >
      {label}
    </Button>
  );
};

export default NavbarConnectButton;
